import { defineMessages } from 'react-intl';

export default defineMessages({
    longerLoansOfferTypeHeading: {
        id: '_.offer_type_select.longer_loans_offer_type_heading',
        defaultMessage: 'I want my offer terms to be'
    },
    flexibleLoansTitle: {
        id: '_.offer_type_select.flexi_loans_title',
        defaultMessage:
            '<strong>Flexible Loans {maxYear}:</strong> repay early from day 1'
    },
    flexibleLoansTitle_withIOoption: {
        id: '_.offer_type_select.flexi_loans_title_with_interest_only',
        defaultMessage:
            '<strong>Flexible Loans</strong>:repay any time, no early repayment fees'
    },
    longerLoansTitle: {
        id: '_.offer_type_select.longer_loans_title',
        defaultMessage:
            '<strong>Longer Durations:</strong> smaller monthly repayments'
    },
    rblTitle: {
        id: '_.offer_type_select.rbl_title',
        defaultMessage:
            '<strong>Ebay revenue:</strong> (select the percentage of revenue you’d like to repay with)'
    }
});
